import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ag{align-items:flex-start;}.ssr-plugin'
import '.c{gap:1.5rem;}.ssr-plugin'
import '.dj{background:var(--palette-white);}.ssr-plugin'
import '.s{flex-direction:row;}.ssr-plugin'
import '.gw{justify-content:flex-start;}.ssr-plugin'
import '.gf{gap:2.5rem;}.ssr-plugin'
import '.ah{flex-wrap:wrap;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.u{gap:0.5rem;}.ssr-plugin'
import '.lr{font-size:4rem;}.ssr-plugin'
import '.cn{font-weight:700;}.ssr-plugin'
import '.l8{line-height:100%;}.ssr-plugin'
import '.ie{margin:0px;}.ssr-plugin'
import '.a3{color:var(--brand-secondary);}.ssr-plugin'
import '.a4{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'

export interface NutshellItem {
  total: string | number
  subtitle: string
}

export interface NutshellProps {
  heading: string
  items: NutshellItem[]
  style?: Style
}

export const Nutshell = ({ heading, items, style }: NutshellProps) => {
  return (
    <styled.div className="d e ag c dj"
      data-testid="nutshell"
      style={{
        ...style,
      }}
    >
      {/* Heading */}
      <Title.H4
        style={{
          color: 'var(--brand-secondary)',
          textAlign: 'center',
          margin: 0,
        }}
      >
        {heading}
      </Title.H4>

      {/* Data Points Container */}
      <div className="d s gw ag gf ah"
      >
        {items.map((item, index) => (
          <div className="d e t u"
            key={index}
          >
            <div className="lr cn l8 ie a3 a4"
            >
              {item.total}
            </div>

            {/* Subtitle */}
            <Text.Medium
              style={{
                color: 'var(--brand-secondary)',
                opacity: 0.6,
                margin: 0,
                textAlign: 'center',
              }}
            >
              {item.subtitle}
            </Text.Medium>
          </div>
        ))}
      </div>
    </styled.div>
  )
}
